import { call, put, takeEvery } from "redux-saga/effects";
import { lopTinChiApi } from "../../../api/lop-tin-chi/lopTinChiApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eDanhSachLopTinChiActionIds, IDanhSachLopTinChiActions } from "../../action-types/lop-tin-chi/IDanhSachLopTinChiActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.lopTinChiWrapper.danhSachLopTinChi;
export function* danhSachLopTinChiSaga(): any {
  yield takeEvery(eDanhSachLopTinChiActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IDanhSachLopTinChiActions): any {
  const res: IBaseRespone = yield call(lopTinChiApi.SelectDanhSachLopTinChi, action.payload as number);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS({
      id: action.payload as number,
      data: res.data
    }));
  } else {
    yield put(mainAction.LOAD_ERROR({
      id: action.payload as number,
      data: res.message ?? "Có lỗi"
    }));
  }
}
